import { z } from 'zod';
import { BenefitCategory } from 'store/benefits';
import { IFile } from 'types/income';
import { ContentLanguage } from 'types/general';
import { UploadedFile } from 'store/files';
import { Translations } from 'types/Common';
import { benefitTemplatesFiltersSchema } from './benefit-templates.schemas';

export const benefitTemplateStatuses = ['active', 'inactive'] as const;
export type BenefitTemplateStatus = (typeof benefitTemplateStatuses)[number];

export interface BaseBenefitTemplate {
  id: string;
  name: string;
  status: BenefitTemplateStatus;
  category: BenefitCategory;
  copiesMade: number;
  modifiedAt: string;
}

export interface BenefitTemplate extends BaseBenefitTemplate {
  thumbnailId: string;
  thumbnail?: IFile;
  supportedCountries: string[];
  defaultLanguage: Uppercase<ContentLanguage>;
  supportedLanguages: Uppercase<ContentLanguage>[];
  translations: Translations<{
    title: string;
    description: string;
    image: UploadedFile | null;
    links: Array<{
      index: number;
      name: string;
      url: string;
    }>;
    attachments: Array<{
      id: string;
      name: string;
      fileId: string;
      file?: IFile;
      index: number;
    }>;
    faq: Array<{ index: number; question: string; answer: string }>;
  }>;
}

export type BenefitTemplatesFilters = z.infer<
  typeof benefitTemplatesFiltersSchema
>;
